import { ComponentProps } from "react";

import { useT } from "@/i18n";
import { League } from "@/types";
import { getIconSize, IconSize } from "@/ui";
import { cn } from "@/utils/cn";
import { getAvatarPlaceholderUrl } from "@/utils/common";

export type LeagueLogoProps = {
  league: Pick<League, "title" | "logo">;
  width?: number;
  height?: number;
  size?: IconSize;
} & Omit<ComponentProps<"img">, "src" | "alt" | "aria-label">;

export const LeagueLogo = ({
  league,
  className,
  width,
  height,
  size,
  ...props
}: LeagueLogoProps) => {
  const t = useT();

  const label = t("league.components.logo.label", {
    name: league.title,
  });

  const sizePx = getIconSize(size);

  return (
    <img
      src={league.logo || getAvatarPlaceholderUrl(league.title)}
      alt={label}
      aria-label={label}
      style={{ width: width ?? sizePx, height: height ?? sizePx }}
      className={cn("shrink-0 object-contain rounded-sm", className)}
      {...props}
    />
  );
};
